<div
  class="iconContainer"
  [style.background]="inactive ? '#E6E6E6' : therapyItem.secondaryColor"
  [style.color]="inactive ? '#ACACAC' : therapyItem.color"
>
  <itl-alberta-icon [name]="therapyItem.iconName"></itl-alberta-icon>
</div>
